"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireDefault(require("react"));

var _propTypes = babelHelpers.interopRequireDefault(require("prop-types"));

var _shallowEqual = babelHelpers.interopRequireDefault(require("../utils/shallowEqual"));

// @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-flow-strip-types", "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}
var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  var className = props.className,
      elementRef = props.elementRef,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onReady = props.onReady,
      paymentRequest = props.paymentRequest,
      options = babelHelpers.objectWithoutProperties(props, ["className", "elementRef", "onBlur", "onClick", "onFocus", "onReady", "paymentRequest"]);
  return options;
};

var PaymentRequestButtonElement =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(PaymentRequestButtonElement, _React$Component);

  function PaymentRequestButtonElement(props, context) {
    var _this;

    babelHelpers.classCallCheck(this, PaymentRequestButtonElement);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PaymentRequestButtonElement).call(this, props, context));

    _this.handleRef = function (ref) {
      _this._ref = ref;
    };

    var options = _extractOptions(props);

    _this._element = _this.context.elements.create('paymentRequestButton', babelHelpers.objectSpread({
      paymentRequest: props.paymentRequest
    }, options));
    _this._options = options;

    _this._element.on('ready', function () {
      _this.props.elementRef(_this._element);

      _this.props.onReady();
    });

    _this._element.on('focus', function () {
      var _this$props;

      return (_this$props = _this.props).onFocus.apply(_this$props, arguments);
    });

    _this._element.on('click', function () {
      var _this$props2;

      return (_this$props2 = _this.props).onClick.apply(_this$props2, arguments);
    });

    _this._element.on('blur', function () {
      var _this$props3;

      return (_this$props3 = _this.props).onBlur.apply(_this$props3, arguments);
    });

    return _this;
  }

  babelHelpers.createClass(PaymentRequestButtonElement, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._element.mount(this._ref);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.paymentRequest !== nextProps.paymentRequest) {
        console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
      }

      var options = _extractOptions(nextProps);

      if (Object.keys(options).length !== 0 && !(0, _shallowEqual.default)(options, this._options)) {
        this._options = options;

        this._element.update(options);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._element.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.props.className,
        ref: this.handleRef
      });
    }
  }]);
  return PaymentRequestButtonElement;
}(_react.default.Component);

PaymentRequestButtonElement.propTypes = {
  className: _propTypes.default.string,
  elementRef: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onReady: _propTypes.default.func,
  paymentRequest: _propTypes.default.shape({
    canMakePayment: _propTypes.default.func.isRequired,
    on: _propTypes.default.func.isRequired,
    show: _propTypes.default.func.isRequired
  }).isRequired
};
PaymentRequestButtonElement.defaultProps = {
  className: '',
  elementRef: noop,
  onBlur: noop,
  onClick: noop,
  onFocus: noop,
  onReady: noop
};
PaymentRequestButtonElement.contextTypes = {
  elements: _propTypes.default.object.isRequired,
  registerElement: _propTypes.default.func.isRequired,
  unregisterElement: _propTypes.default.func.isRequired
};
var _default = PaymentRequestButtonElement;
exports.default = _default;